import {
  Dialog as DialogComponent,
  DialogTitle as DialogTitleComponent,
  DialogContent as DialogContentComponent,
  LinearProgress as LinearProgressComponent,
} from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Dialog = lib.styled(DialogComponent)`
  width: 400px !important;
  margin: auto;

  .MuiDialog-paper {
    margin: 10px;
    height: 715px !important;
  }

  .rst__tree {
    zoom: 97%;
  }
`;

export const LinearProgress = lib.styled(LinearProgressComponent)`
  &.MuiLinearProgress-root {
    height: 5px;
  }

  &.MuiLinearProgress-colorPrimary {
    background-color: ${colors.lightGreen02};
  }

  & .MuiLinearProgress-barColorPrimary {
    background-color: ${colors.green02};
  }
`;

export const DialogTitle = lib.styled(DialogTitleComponent)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px !important;
  
  .details {
    display: flex;
    flex: 1;
    flex-direction: column;
    margin-left: 10px;
    gap: 5px;

    .header-name {
      font-size: 17px;
      font-weight: 500;
      font-family: Nunito!important;
      padding-top: 10px;
      padding-bottom: 20px;
    }

    .contact-name {
      font-size: 16px;
      color: #535353;
      font-weight: bold;
    }

    .number-from {
      font-size: 15px;
      color: #dddcdc;
    }
  }

  .actions {
    margin-top: -58px;

    .countdown {
      font-size: 17px;
      font-weight: normal !important;
      margin-right: 12px;
    }
  }

  span {
    font-size: 18px;
    font-weight: 600!important;
  }
`;

export const DialogContent = lib.styled(DialogContentComponent)`
  padding: 5px !important;
  overflow: scroll;

  .title-notes {
    span {
      font-size: 14px;
    }

    span:after {
      content: ' *'
    }
  }

  .close-icon {
    display: none;
  }

  .groupBtns {
    .off {
      display: none;
    }
  }

  .addtags-container {
    padding: 0;
    background-color: unset;

    .addtags-container-title {
      font-size: 14px;
    }

    .addtags-container-title:after {
      content: ' *'
    }
  }

  .showtags-container {
    margin-top: 20px;
    margin-bottom: 15px;
  }
`;

export const CustomBtn = lib.styled.button`
  display: flex;
  width: 85px;
  height: 26px;
  justify-content: center;
  align-items: center;
  align-self: flex-end;
  font-size: 14px;
  font-weight: 800;
  font-family: Nunito!important;
  color: #FFF;
  border-width: 0px;
  border-radius: 50px;
  cursor: pointer;
  background: linear-gradient(50.28deg,#67C2E4 2.79%,#0C4BBC 73.37%);
  margin: 15px -9px 7px 0;
  &:focus {
    outline: 0;
  }

  .loader {
    color: ${colors.white}
  }
`;
